<div class="slide-div">
  <owl-carousel-o [options]="customOptions">
    <ng-template *ngIf="produtoVideo" carouselSlide>
      <div style="width: 100%; height: 270px; display: flex; justify-content: center; align-items: center;"
        (click)="openZoom()">
        <iframe width="480" height="270" [src]="produtoVideo" frame-border="0" title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
    </ng-template>
    <ng-container *ngFor="let imagem of imagensFinal; let i = index">
      <ng-template carouselSlide>
        <a class="box-creative" style="height: 270px; cursor: pointer;" (click)="openZoom(imagem.url, i)">
          <div class="box-creative-inner" style="height: 270px">
            <img [alt]="alt" [src]="imagem.url" style="height: 270px !important; width: auto;" draggable="false" />
          </div>
        </a>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>

<p-dialog [(visible)]="visible" [modal]="true" [dismissableMask]="true" [closable]="false"
  [style]="{ width:'95vw', borderRadius:'10px', padding: '10px'}" draggable="false">
  <img src="../assets/images/icons/close.svg" width="24" height="24" class="btn-close" (click)="visible = false">

  <ng-template pTemplate="header">
    <div class="tabs-header">
      <nav mat-tab-nav-bar class="tabs-nav">
        <a mat-tab-link [active]="activeTab === 'imagens'" (click)="onClickImagesTab()">Imagens</a>
        <a mat-tab-link [active]="activeTab === 'videos'" (click)="activeTab = 'videos'">Vídeos</a>
      </nav>
    </div>
  </ng-template>

  <div class="dialog-content">
    <section *ngIf="activeTab === 'videos' && !!produtoVideo" class="tab-body videos-layout">
      <div class="main-video-col">
        <div class="video-box">
          <iframe [src]="produtoVideo" title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen [ngStyle]="{height: setResize(45).toString() + 'px'}"></iframe>
          <!-- <div class="principal-review">
            <p style="margin: 0.8rem 0; font-size: 16px;">O melhor desenho da minha infância.</p>
            <div class="principal-review-info">
              <img src="../../../assets/images/icons/account.svg" height="30" width="30"
                style="margin-bottom: 1rem; margin-right: 0.5rem;" />
              <div
                style="display: flex; flex-direction: column; font-family: Arial; font-size: 14px; margin-bottom: 1rem;">
                <div style="display: inline-flex; align-items: center; gap: 8px;">
                  <p style="margin: 0;">Ricardo</p>
                  <p style="margin: 0;">★★★★★</p>
                  <p style="margin: 0; color: orange;">Compra Verificada</p>
                </div>
                <div style="margin: 0;">Avaliado no Brasil em 24 de setembro de 2025</div>
              </div>

            </div>
            <p>Reviva as emocionantes aventuras da icônica série de desenhos animados "Caverna do Dragão" com as Action
              Figures Vingador e Mestre dos Magos da Hasbro. Estas figuras colecionáveis trazem à vida dois dos
              personagens mais memoráveis da série, cada um com detalhes incrivelmente precisos.</p>
          </div> -->
        </div>
      </div>
      <div class="thumbs-col">
        <mat-card appearance="raised" class="videos-card">
          <mat-card-content>Vídeos Promocionais</mat-card-content>
        </mat-card>
        <div *ngIf="promotionalVideos.length > 0; else noPromotionalVideos"></div>
        <div class="product-videos" *ngFor="let video of promotionalVideos">
          <button (click)="handleVideoClick(video.url)" type="button" class="btn-reset">
            <div class="product-video-item">
              <div class="w-50">
                <img *ngIf="video.thumbnailUrl" [src]="video.thumbnailUrl" height="77" width="131">
              </div>
              <div class="w-50 info-video">
                <p>{{video.title| ellipsis:60}}</p>
                <!-- <p style="font-size: 12px; ">Inversu</p> -->
              </div>
            </div>
          </button>
        </div>
        <ng-template #noPromotionalVideos>
          <div class="product-videos">
            <button class="btn-reset">
              Não existem vídeos promocionais para este produto... ainda.
            </button>
          </div>
        </ng-template>
        <mat-card appearance="raised" class="avaliations-card">
          <mat-card-content>Vídeos de Avaliação</mat-card-content>
        </mat-card>
        <div *ngIf="reviewVideos.length > 0; else noReviewVideos"></div>
        <div class="product-reviews" *ngFor="let video of reviewVideos">
          <button (click)="handleVideoClick(video.url)" type="button" class="btn-reset">
            <div class="product-video-item">
              <div class="w-50">
                <img *ngIf="video.thumbnailUrl" [src]="video.thumbnailUrl" height="77" width="131">
              </div>
              <div class="w-50 info-video">
                <p>{{video.title| ellipsis:60}}</p>
                <!-- <p style="font-size: 12px; ">Inversu</p> -->
              </div>
            </div>
          </button>
        </div>
        <ng-template #noReviewVideos>
          <div class="product-reviews">
            <button class="btn-reset">
              Não existem vídeos de avaliações para este produto... ainda.
            </button>
          </div>
        </ng-template>
      </div>
    </section>
    <div *ngIf="activeTab === 'videos' && !videos?.length" class="no-videos">
      <p>Este produto não possui vídeos... ainda.</p>
    </div>

    <section *ngIf="activeTab === 'imagens' && imagensFinal?.length" class="tab-body"
      [class.mobile-zoom-container-scroll]="isMobileView && imagemAtualScale > 1"> <p-galleria [value]="imagemAtualUrl"
        [visible]="displayImages" [responsiveOptions]="galeriaResponsiveOptions"
        [containerStyle]="{ width: '100%', border: 'none' }" [numVisible]="5" [circular]="false"
        [showItemNavigators]="false" [showIndicators]="false" [showThumbnailNavigators]="false">
        <ng-template pTemplate="item" let-item>
          <div class="zoom-box" (click)="onZoomToggle()" (mousemove)="!isMobileView ? onZoomMove($event) : null"
            [style.cursor]="!isMobileView && imagemAtualScale > 1 ? 'move' : 'zoom-in'"> <img *ngIf="item.url"
              [src]="item.url" class="galleria-full" [class.is-zoomed-mobile]="isMobileView && imagemAtualScale > 1"
              [style.transform]="!isMobileView ? 'scale(' + imagemAtualScale + ')' : null"
              [style.transform-origin]="!isMobileView ? transformOrigin : null"
              style="transition: transform 0.3s ease;" />
          </div>
        </ng-template>
      </p-galleria>
      <div class="zoom-icons">
        <div><button class="btn-reset" (click)="scaleUp()"><img src="../../../assets/images/icons/zoom_in.svg"
              height="60px" width="60px" draggable="false" /></button></div>
        <div><button class="btn-reset" (click)="scaleDown()"><img src="../../../assets/images/icons/zoom_out.svg"
              height="60px" width="60px" draggable="false" /></button></div>
      </div>
      <div class="info-col">
        <p style="font-size: 16px;">
          {{produtoNome}}
        </p>
        <p style="font-size: 14px; color: gray; margin-bottom: 2rem;">
          Marca: {{produtoMarca}}
        </p>
        <div key="index" class="images-iterate">
          <img *ngFor="let image of imagensFinal; let index = index" [src]="image.url" [alt]="alt"
            style="cursor: pointer; border: 2px solid rgba(128, 128, 128, 0.300); padding: 0.1rem;" height="80px"
            width="80px" (click)="handleImageClick(index, image.url)"
            [ngClass]="{'selected': indiceSelecionado === index}" />
        </div>
      </div>
    </section>
  </div>
</p-dialog>
